export const COMPONENT_START_INDEX = 1;
export const COMPONENT_INDEX_INCREASE_VALUE = 1;
